import { create } from 'zustand';

interface PageBackButtonState {
  /**
   * The path the app-chrome back button should navigate to, or `null` when no back button
   * should be shown. Page-level layouts set this while mounted so the top-level AppLayout can
   * render the shared CoreUI back button in the header gutter without reserving body width.
   *
   * Assumes a single mounted publisher at a time: this is a module-level singleton, so the
   * last writer wins. This holds today because react-router's `Switch` unmounts the outgoing
   * page (running its cleanup) in the same commit as the incoming page mounts. If overlapping
   * publishers ever become possible (e.g. nested layouts), key the setter/cleanup off an owner
   * id so a stale clear can't wipe an active target.
   */
  readonly backTargetPath: string | null;
}

const usePageBackButtonStore = create<PageBackButtonState>(() => ({ backTargetPath: null }));

export const usePageBackButtonTargetPath = (): string | null => usePageBackButtonStore((state) => state.backTargetPath);

export const setPageBackButtonTargetPath = (backTargetPath: string | null): void => {
  usePageBackButtonStore.setState({ backTargetPath });
};
